export const CarouselData = [
  {
    type: "image",
    src: "https://originalbucket.originalmarines.com/Grafiche_sito/2025/04marzo/Desktop_PROMO_1_FULL_LASTCHANCE_04032025.jpg",
    link: "/items/filter?page=1&is_sale=1",
  },
  // {
  //   type: "video",
  //   src: "https://cdn-media.originalmarines.com/pub/media/video/FW24_Slider_Desktop_05112024.mp4",
  // },
];
// https://originalbucket.originalmarines.com/Grafiche_sito/2025/13gennaio/Sale_eng_NET_Desktop_full_fino70_fw24_13012025.jpg
